import delay from 'lodash/delay';
import React from 'react';
import PropTypes from 'prop-types';

import Picture from '../../Picture';

const pulseClick = ({ currentTarget: el }) => {
  const callback = () => el.blur();
  delay(callback, 150);
};

class Relative extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onKeyup = this.onKeyup.bind(this);
    this.handleMenuToggle = this.handleMenuToggle.bind(this);
    this.handleNextClick = this.handleNextClick.bind(this);
    this.handlePreviousClick = this.handlePreviousClick.bind(this);
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('keyup', this.onKeyup);
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('keyup', this.onKeyup);
    }
  }

  onKeyup(event) {
    const {
      handleMenuToggle,
      handleNextClick,
      handlePreviousClick,
    } = this.props;
    switch (event.keyCode) {
      case 77: // m
        handleMenuToggle(event);
        break;
      case 37: // arrow-left
        handlePreviousClick(event);
        break;
      case 39: // arrow-right
        handleNextClick(event);
        break;
      default: // no-default
    }
  }

  handleMenuToggle(event) {
    event.preventDefault();
    pulseClick(event);
    this.props.handleMenuToggle(event);
  }

  handleNextClick(event) {
    event.preventDefault();
    pulseClick(event);
    this.props.handleNextClick(event);
  }

  handlePreviousClick(event) {
    event.preventDefault();
    pulseClick(event);
    this.props.handlePreviousClick(event);
  }

  render() {
    const { canMoveNext, canMovePrevious, open } = this.props;
    return (
      <nav className="relative">
        <button
          className="arrow previous"
          disabled={!canMovePrevious}
          onClick={this.handlePreviousClick}
          onKeyUp={this.onKeyUp}
          type="button"
        >
          <Picture alt="Arrow Icon [left]" filepath="ui/arrow-left" />
          <span className="sr-only">Previous</span>
        </button>
        <button
          aria-controls="menu"
          aria-expanded={open}
          aria-label={`${open ? 'Close' : 'Open'} Menu`}
          className="toggle"
          onClick={this.handleMenuToggle}
          onKeyUp={this.onKeyUp}
          type="button"
        >
          <Picture alt="Menu Icon" className={['menu']} filepath="ui/menu" />
          <Picture
            alt="Menu Close Icon"
            className={['close']}
            filepath="ui/close"
          />
          <span className="sr-only">{open ? 'Close' : 'Open'} Menu</span>
        </button>
        <button
          className="arrow next"
          disabled={!canMoveNext}
          onClick={this.handleNextClick}
          onKeyUp={this.onKeyUp}
          type="button"
        >
          <Picture alt="Arrow Icon [right]" filepath="ui/arrow-right" />
          <span className="sr-only">Next</span>
        </button>
      </nav>
    );
  }
}

Relative.propTypes = {
  canMoveNext: PropTypes.bool.isRequired,
  canMovePrevious: PropTypes.bool.isRequired,
  handleMenuToggle: PropTypes.func.isRequired,
  handleNextClick: PropTypes.func.isRequired,
  handlePreviousClick: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default Relative;



// WEBPACK FOOTER //
// ./src/components/navigation/Relative/index.js